import CreateTransactionRequestModelBase from '../_generated/modelBases/create-transaction-request-model-base';

export default class CreateTransactionRequestModel extends CreateTransactionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
